@if (!routingService.$isMobile() && routingService.getFormMode(LANDMARKS)) {
  @if (isDeployed) {
    <div class="container-deployed">
      <div class="container-gif">
        <video
          autoplay
          loop
          [src]="actionsGif[selectedIndex]"
          type="video/webm"
          height="240"
          width="410"></video>
        <div class="container-action-gif">
          <div class="container-back">
            <i (click)="toggleDeploy()" [matTooltip]="'COMMON.CLOSE' | translate" class="material-icons">
              close
            </i>
          </div>
          <div class="container-keyboard">
            <i
              [class]="selectedIndex === 0 ? 'material-icons icon-disabled' : 'material-icons icon-active'"
              (click)="changeIndex(selectedIndex, -1)">
              keyboard_arrow_left
            </i>
            <i
              [class]="
                selectedIndex === actionsData.length - 1
                  ? 'material-icons icon-disabled'
                  : 'material-icons icon-active'
              "
              (click)="changeIndex(selectedIndex, 1)">
              keyboard_arrow_right
            </i>
          </div>
        </div>
      </div>
      <div class="container-action">
        <mat-tab-group
          color="accent"
          #tabGroup
          [disablePagination]="true"
          [selectedIndex]="selectedIndex"
          (selectedIndexChange)="changeIndex($event, 0)">
          @for (action of actionsData; track action) {
            <mat-tab [label]="'COMMON.' + action | translate">
              @if (action === actionsData[0]) {
                <div class="container-column-center">
                  <img class="material-icons" src="assets/left-click.svg" alt="Left click" />
                  <p class="marg-top-ten">
                    {{ 'MAP.TUTORIAL.SEVERAL_ON_MAP' | translate }}
                  </p>
                </div>
              }
              @if (action === actionsData[1]) {
                <div class="container-column-center">
                  <p>
                    <img class="material-icons" src="assets/left-click.svg" alt="Left click" />
                    x 2
                  </p>
                  <p class="marg-top-five">{{ 'MAP.TUTORIAL.OR' | translate }}</p>
                  <div class="btn-rounded-blue-row">
                    <i class="material-icons">done</i>
                    {{ 'MAP.TUTORIAL.VALID_POLYGON' | translate }}
                  </div>
                </div>
              }
              @if (action === actionsData[2]) {
                <div class="container-column-center">
                  <img class="material-icons" src="assets/left-click.svg" alt="Left click" />
                  <p>
                    {{ 'MAP.TUTORIAL.ON' | translate }}
                    {{ 'MAP.TUTORIAL.POLYGON' | translate }}
                  </p>
                  <p class="marg-top-five marg-bottom-five">
                    {{ 'MAP.TUTORIAL.OR' | translate }}
                  </p>
                  <p>
                    {{ 'MAP.TUTORIAL.ON' | translate }}
                    {{ 'MAP.TUTORIAL.POINTS' | translate }}
                  </p>
                </div>
              }
              @if (action === actionsData[3]) {
                <div class="container-column-center">
                  <p>
                    <img class="material-icons" src="assets/left-click.svg" alt="Left click" />
                    {{ 'MAP.TUTORIAL.ON' | translate }}
                  </p>
                  <div class="btn-rounded-blue-row">
                    <i class="material-icons">delete</i>
                    {{ 'COMMON.DELETE' | translate }}
                    {{ 'MAP.TUTORIAL.POLYGON' | translate }}
                  </div>
                </div>
              }
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
  } @else {
    <div [matTooltip]="'MAP.TUTORIAL.TUTO' | translate" class="container-icon" (click)="toggleDeploy()">
      <i class="material-icons">help</i>
    </div>
  }
}
